import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export type TCarrierFormFieldsName = {
    cardNumber: string;
    emitterBank: string;
    startDate: string;
    binID: string;
    expirationDate: string;
    binType: string;
    productType: string;
    prepaidCardIndicator: string;
    cardType: string;
    indicatorFileCRBException: string;
    association: string;
    authorizationCode: string;
    authorizationSourceCode: string;
    authorizedAmount: string;
    atmAccountSelection: string;
    currencyCode: string;
    responseCode: string;
    [name: string]: string;
};

export interface ICarrierFormMeta {
    // Carrier information
    cardNumber: FormInputMeta;
    emitterBank: FormInputMeta;
    startDate: FormInputMeta;
    binID: FormInputMeta;
    expirationDate: FormInputMeta;
    binType: FormInputMeta;
    productType: FormInputMeta;
    prepaidCardIndicator: FormInputMeta;
    cardType: FormInputMeta;
    indicatorFileCRBException: FormInputMeta;
    association: FormInputMeta;

    // Authorization information
    authorizationCode: FormInputMeta;
    authorizationSourceCode: FormInputMeta;
    authorizedAmount: FormInputMeta;
    atmAccountSelection: FormInputMeta;
    currencyCode: FormInputMeta;
    responseCode: FormInputMeta;

    schema: any;
}

const carrierFormMeta = {} as ICarrierFormMeta;

// Carrier information
carrierFormMeta.cardNumber = {
  name: "cardNumber",
  type: "text",
  label: "Numéro Carte",
  placeholder: "",
  validation: yup.string(),
};

carrierFormMeta.emitterBank = {
  name: "emitterBank",
  type: "text",
  label: "Banque Emittrice",
  placeholder: "",
  validation: yup.string(),
};

carrierFormMeta.startDate = {
  name: "startDate",
  type: "date",
  label: "Date Début",
  placeholder: "",
  validation: yup.string(),
};

carrierFormMeta.binID = {
  name: "binID",
  type: "text",
  label: "ID Bin",
  placeholder: "",
  validation: yup.string(),
};

carrierFormMeta.expirationDate = {
  name: "expirationDate",
  type: "date",
  label: "Date Expiration",
  placeholder: "",
  validation: yup.string(),
};

carrierFormMeta.binType = {
  name: "binType",
  type: "text",
  label: "Type Bin",
  placeholder: "",
  validation: yup.string(),
};

carrierFormMeta.productType = {
  name: "productType",
  type: "text",
  label: "Type Produit",
  placeholder: "",
  validation: yup.string(),
};

carrierFormMeta.prepaidCardIndicator = {
  name: "prepaidCardIndicator",
  type: "text",
  label: "Indicateur Carte Pré-payée",
  placeholder: "",
  validation: yup.string(),
};

carrierFormMeta.cardType = {
  name: "cardType",
  type: "text",
  label: "Type Carte",
  placeholder: "",
  validation: yup.string(),
};

carrierFormMeta.indicatorFileCRBException = {
  name: "indicatorFileCRBException",
  type: "text",
  label: "CRB/Exception File Indicator",
  placeholder: "",
  validation: yup.string(),
};

carrierFormMeta.association = {
  name: "association",
  type: "text",
  label: "Association",
  placeholder: "",
  validation: yup.string(),
};

// Authorization information
carrierFormMeta.authorizationCode = {
    name: "authorizationCode",
    type: "text",
    label: "Code Autorisation",
    placeholder: "",
    validation: yup.string(),
}

carrierFormMeta.authorizationSourceCode = {
    name: "authorizationSourceCode",
    type: "text",
    label: "Code Source Autorisation",
    placeholder: "",
    validation: yup.string(),
}

carrierFormMeta.authorizedAmount = {
    name: "authorizedAmount",
    type: "text",
    label: "Montant Autorisé",
    placeholder: "",
    validation: yup.string(),
}

carrierFormMeta.atmAccountSelection = {
    name: "atmAccountSelection",
    type: "text",
    label: "Sélection Compte ATM",
    placeholder: "",
    validation: yup.string(),
}

carrierFormMeta.currencyCode = {
    name: "currencyCode",
    type: "text",
    label: "Devise",
    placeholder: "",
    validation: yup.string(),
}

carrierFormMeta.responseCode = {
    name: "responseCode",
    type: "text",
    label: "Code Réponse",
    placeholder: "",
    validation: yup.string(),
}


carrierFormMeta.schema = yup.object().shape(getValidationSchema(carrierFormMeta));

export default carrierFormMeta;